var _mask, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRupayCardBg = function SvgRupayCardBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 120,
    height: 18,
    fill: "none"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "rupayCardBg_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#337936",
    d: "M0 0h120v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#rupayCardBg_svg__a)",
    d: "M0 0h120v10a8 8 0 0 1-8 8H8a8 8 0 0 1-8-8z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.5,
    d: "M0 0h120zm121 10a9 9 0 0 1-9 9H8a9 9 0 0 1-9-9h2a7 7 0 0 0 7 7h104a7 7 0 0 0 7-7zM8 19a9 9 0 0 1-9-9V0h2v10a7 7 0 0 0 7 7zM121 0v10a9 9 0 0 1-9 9v-2a7 7 0 0 0 7-7V0z",
    mask: "url(#rupayCardBg_svg__b)",
    style: {
      mixBlendMode: "screen"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "rupayCardBg_svg__a",
    x1: -32,
    x2: 66.812,
    y1: -8.5,
    y2: 93.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7BE8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.382,
    stopColor: "#CE6408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.668,
    stopColor: "#CE6408"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7A78B"
  })))));
};
export default SvgRupayCardBg;